import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function Main() {
  const data = [
    {
      id: 1,
      img: "assets/images/sponsors/sponsor-1-1.png",
    },
    {
      id: 2,
      img: "assets/images/sponsors/sponsor-1-2.png",
    },
    {
      id: 3,
      img: "assets/images/sponsors/sponsor-1-3.png",
    },
    {
      id: 4,
      img: "assets/images/sponsors/sponsor-1-4.png",
    },
    {
      id: 5,
      img: "assets/images/sponsors/sponsor-1-1.png",
    },
    {
      id: 6,
      img: "assets/images/sponsors/sponsor-1-2.png",
    },
    {
      id: 7,
      img: "assets/images/sponsors/sponsor-1-3.png",
    },
    {
      id: 8,
      img: "assets/images/sponsors/sponsor-1-4.png",
    },
  ];

  return (
    <>
        {/* <section className="sponsor-one">
          <div className="container">
            <div className="row gutter-y-30 align-items-center">
              <div className="col-lg-4">
                <div className="sponsor-one__content">
                  <p className="sponsor-one__tagline">Global clients</p>

                  <h3 className="sponsor-one__title">
                    We’ve more than 1023+ global clients
                  </h3>
                </div>
              </div>

              <div className="col-lg-8">
                <Swiper
                  spaceBetween={30}
                  slidesPerView={2}
                  loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    576: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    1200: {
                      slidesPerView: 4,
                      spaceBetween: 57,
                    },
                  }}
                >
                  {data.map((item) => (
                    <SwiperSlide key={item.id}>
                      <div className="sponsor-one__item">
                        <img src={item.img} alt={`Sponsor ${item.id}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </section> */}
    </>
  );
}

export default Main;
